import { render, staticRenderFns } from "./others.vue?vue&type=template&id=dc1159b2&scoped=true&"
import script from "./others.vue?vue&type=script&lang=js&"
export * from "./others.vue?vue&type=script&lang=js&"
import style0 from "./others.vue?vue&type=style&index=0&id=dc1159b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1159b2",
  null
  
)

export default component.exports